export enum RedirectType {
  login = 0,
  assignIdpUser = 1,
  addContract = 2,
  removeContract = 3,
  message = 4,
}
